import { http } from "@canvas/api";

export interface LendingsSearchReq {
  endpoint: "ragnarok.swatch.v1.lendings.search";
  query: string;
}

export interface LendingsSearchRes {}

export function get(req: LendingsSearchReq): Promise<LendingsSearchRes> {
  return http
    .GET(`/ragnarok/swatch/v1/lendings?${req.query}`)
    .then((response: LendingsSearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
